import { render } from "./ViewEmailConfiguration.vue?vue&type=template&id=0b55d614&scoped=true"
import script from "./ViewEmailConfiguration.vue?vue&type=script&lang=js"
export * from "./ViewEmailConfiguration.vue?vue&type=script&lang=js"

import "./email-configuration.scss?vue&type=style&index=0&id=0b55d614&lang=scss&scoped=true&external"

import exportComponent from "../../../../../../../orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b55d614"]])

export default __exports__